<template>
  <base-dialog
    width="calc(100vw - 400px)"
    show-close
    :visible.sync="visible"
    class="select-available-master-rule-dialog"
  >
    <template v-slot:header>互联规则</template>
    <div class="top-wrap">
      <el-input
        v-model="curSearchText"
        size="small"
        placeholder="搜索"
        clearable
        @keyup.native.enter="searchText = curSearchText"
        @clear="searchText = curSearchText"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchText = curSearchText"
        ></el-button>
      </el-input>
    </div>
    <base-table
      ref="table"
      :data="filteredRuleList"
      @row-click="rowClick"
      @selection-change="handleSelectionChange"
      frontend-pagination
      :page-info="pageInfo"
    >
      <el-table-column fixed align="center" type="selection" width="50"></el-table-column>
      <el-table-column
        v-for="(item, index) in availableMasterTableColumns"
        :key="index"
        :prop="item.value"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :align="item.align"
        :show-overflow-tooltip="item.showOverflowTooltip"
      ></el-table-column>
    </base-table>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import BaseTable from "@/components/UIComponents/BaseTable"
import { createSyncRuleSlaves, getAvailableRuleList } from "@/api/connect"
import { availableMasterTableColumns } from "./static"

export default {
  name: "select-available-master-rule-dialog",
  components: { BaseDialog, BaseButton, BaseTable },
  inject: ["app"],
  data() {
    return {
      visible: false,
      availableMasterTableColumns,
      ruleList: [],
      selection: [],
      searchText: "",
      curSearchText: "",
      pageInfo: { total: 0, currentPage: 1, pageSize: 20 }
    }
  },
  computed: {
    filteredRuleList() {
      let data = this.searchText
        ? this.ruleList.filter(rule => `${rule.name}_${rule.companyName}`.includes(this.searchText))
        : this.ruleList

      Object.assign(this.pageInfo, {
        total: data.length,
        currentPage: 1
      })
      return data
    }
  },
  created() {
    getAvailableRuleList().then(ruleList => {
      this.ruleList = ruleList.map(r => ({
        ...r,
        exportStr: r.export ? "输出" : "接收",
        enableStr: r.enable ? "启用" : "禁用"
      }))
    })
  },
  methods: {
    open() {
      this.visible = true
    },
    rowClick(row) {
      this.$refs.table.toggleSelection(row)
    },
    handleSelectionChange(val) {
      this.selection = val
    },
    submit() {
      if (!this.selection.length) {
        this.$message.warning("请先选中至少一条规则")
        return
      }
      createSyncRuleSlaves(
        this.selection.map(rule => rule.id),
        this.app.id
      ).then(() => {
        this.$message.success("操作成功")
        this.$emit("change")
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-available-master-rule-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    height: calc(100% - 50px);
    min-width: 1080px;
    .el-dialog__body {
      flex: 1;
      padding: 0;
      color: unset;
      display: flex;
      flex-flow: column;
      .base-table {
        flex: 1;
        overflow: hidden;
      }
      .top-wrap {
        display: flex;
        padding: 8px;
        .el-input {
          margin-left: auto;
          width: 240px;
        }
      }
    }
    .el-dialog__footer {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}
</style>
